import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      videoUrl: '', //视频
      userInfo: {}, //
      banners: [],
      homeList: [], //首页列表
      synopsis: null, //公司简介
      huechysList: [], //红娘列表
      // i:0,
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        keyboard: {
          enabled: true,
        },
        autoplay: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      swiperOptions: {
        slidesPerView: 4,
        spaceBetween: 30,
        // slidesPerGroup : 4,
        // loop : true,
        autoplay: true,
        navigation: {
          nextEl: '.swiper-button-nexts',
          prevEl: '.swiper-button-prevs',
        },
      },
      swiperOptiona: {
        slidesPerView: 5,
        // slidesPerGroup : 4,
        spaceBetween: 20,
        // loop : true,
        autoplay: true,
        navigation: {
          nextEl: '.swiper-button-nexts',
          prevEl: '.swiper-button-prevs',
        },
      },
      isShow: true, //播放视频
      emotionList: [], //情感案例
      emotionListLeft: [], //左边的
      emotionListRight: [], //右边的
      isHied: true,
      imgObject: {},
      isshowTxt: true,
    }
  },
  created() {
    this.getVedio()
    this.getPicture()
    this.getBannerList()
    this.getHomeList()
    this.getSynopsis()
    this.getHuechysList()
    this.getEmotionList()
    if (localStorage.getItem('incredible-k')) {
      this.getUserInfo()
    } else {
      this.$router.push('/login')
    }
  },
  methods: {
    //图片轮播
    goActivity(item) {
      if (item.status == 1) {
        location.href = item.url
      } else if (item.status == 2) {
        this.$router.push({ path: '/bannerMessage', query: { id: item.id } })
      }
    },
    //去客服
    goService() {
      location.href = 'http://wpa.qq.com/msgrd?v=3&uin=2484786422&site=qq&menu=yes'
    },
    //去vip详情
    goVipMessage(id) {
      if (this.userInfo.is_member == 1 || this.userInfo.is_member == 3) {
        this.$router.push({ path: '/vipMessage', query: { id } })
      } else {
        this.$router.push({ path: '/applyInitiation' })
      }
    },
    //去情感详情
    goCaseMessage(id) {
      this.$router.push({ path: '/caseMessage', query: { id } })
    },
    //查看更多
    changeMove() {
      this.isHied = false
      this.emotionListLeft = []
      this.emotionListRight = []
      this.emotionList.forEach((item, index) => {
        if (index % 2 == 0) {
          this.emotionListLeft.push(item)
        } else {
          this.emotionListRight.push(item)
        }
      })
    },
    //暂停播放
    pausePlay() {
      this.isShow = true
    },
    //播放视频
    changePlay() {
      this.isShow = false
      this.$refs.video.play()
    },
    //向左
    slidePrev() {
      this.$refs.mySwiper.$swiper.slidePrev()
    },
    //向右
    slideNext() {
      this.$refs.mySwiper.$swiper.slideNext()
    },
    //向左
    referrerPrev() {
      this.$refs.referrer.$swiper.slidePrev()
    },
    //向右
    referrerNext() {
      this.$refs.referrer.$swiper.slideNext()
    },
    //获取轮播图
    getBannerList() {
      this.$axios
        .post('/api/index/banner', {
          type: 2,
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.banners = res.data.data
          }
        })
    },
    //获取征婚榜
    getHomeList() {
      this.$axios.post('/api/index/marrySeek').then((res) => {
        if (res.data.code === 0) {
          this.homeList = res.data.data
        }
      })
    },
    //公司简介
    getSynopsis() {
      this.$axios.post('/api/index/aboutUs').then((res) => {
        if (res.data.code === 0) {
          this.synopsis = res.data.data
        }
      })
    },
    //获取红娘列表
    getHuechysList() {
      this.$axios
        .post('/api/index/newsList', {
          type: 1,
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.huechysList = res.data.data.newsList
          } else {
            this.huechysList = []
          }
        })
    },
    //情感交流列表
    getEmotionList() {
      this.emotionListRight = []
      this.emotionListLeft = []
      this.$axios
        .post('/api/index/newsList', {
          type: 3,
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.emotionList = res.data.data.newsList
            res.data.data.newsList.forEach((item, index) => {
              if (index < 6) {
                if (index % 2 == 0) {
                  this.emotionListLeft.push(item)
                } else {
                  this.emotionListRight.push(item)
                }
              }
            })
          } else {
            this.emotionList = []
          }
        })
    },
    //获取个人信息
    getUserInfo() {
      this.$axios.post('/api/users/getUserInfo').then((res) => {
        if (res.data.code === 0) {
          this.userInfo = res.data.data
          if (res.data.data.check_status != 3) {
            this.$message(res.data.data.ts)
            setTimeout(() => {
              this.$router.push({ path: '/applyInitiation' })
            }, 5000)
          }
        }
      })
    },
    //获取首页图片
    getPicture() {
      this.$axios.post('/api/ban/index').then((res) => {
        if (res.data.code === 0) {
          this.imgObject = res.data.data
        }
      })
    },
    //获取视频
    getVedio() {
      this.$axios.post('/api/address/video').then((res) => {
        if (res.data.code === 0) {
          this.videoUrl = res.data.data
        }
      })
    },
  },
}
